/* Olivine offer page.
 *
 * State is three things: the shade, whether she doubled up, and which add ons are on.
 * Everything visible is derived from those, so there is one render path and no way for
 * the button label, the total and the cart to disagree.
 *
 * Checkout is one POST to /cart/add.js followed by a jump to /checkout, which Phoenix
 * intercepts. The drawer never opens. The cart is cleared first because this page is a
 * destination for a single ad click, and a stale cart from another visit would ride
 * along into an order she never reviewed.
 *
 * The gift brushes are $0.00 listings, never discounted lines. See the section comment.
 */
(function () {
  'use strict';

  document.querySelectorAll('.olv-offer').forEach(setup);

  function setup(root) {
    var cfgEl = root.querySelector('[data-olv-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!cfg.shades || !cfg.shades.length) return;

    var state = {
      shade: (cfg.shades.filter(function (x) { return x.shade === 'Medium'; })[0] || cfg.shades[0]).shade,
      doubled: false,
      addons: {}
    };

    var $ = function (k) { return root.querySelectorAll('[data-olv="' + k + '"]'); };
    var one = function (k) { return root.querySelector('[data-olv="' + k + '"]'); };
    var busy = false;

    /* ---------- money ---------- */

    // Shopify's money_format is Liquid, not a format string a browser understands.
    // Only the amount token varies in practice, so substitute it and keep the rest.
    function money(cents) {
      var n = (cents / 100).toFixed(2);
      var withCommas = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var f = cfg.moneyFormat || '${{amount}}';
      return f.replace(/\{\{\s*amount\s*\}\}/, withCommas)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
              .replace(/<[^>]*>/g, '')
              .trim();
    }

    // "$25" reads harder than "$25.00" on a toggle, so drop a trailing .00 there only.
    function moneyShort(cents) {
      return cents % 100 === 0 ? money(cents).replace(/[.,]00\b/, '') : money(cents);
    }

    /* ---------- derived totals ---------- */

    function shadeRow() {
      for (var i = 0; i < cfg.shades.length; i++) {
        if (cfg.shades[i].shade === state.shade) return cfg.shades[i];
      }
      return cfg.shades[0];
    }

    function addonNodes() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-olv="addon"]'));
    }

    function totals() {
      var base = state.doubled ? cfg.quadPrice : cfg.bogoPrice;
      var compare = state.doubled ? cfg.quadCompare : cfg.bogoCompare;
      var extra = 0, extraSaved = 0, picked = [];
      addonNodes().forEach(function (b) {
        if (!state.addons[b.dataset.key]) return;
        var price = parseInt(b.dataset.price, 10);
        var was = parseInt(b.dataset.was, 10);
        extra += price;
        extraSaved += Math.max(0, was - price);
        picked.push(b.dataset.title);
      });
      var total = base + extra;
      var unlocked = total >= cfg.giftAt;
      return {
        base: base, total: total, picked: picked, unlocked: unlocked,
        toGo: Math.max(0, cfg.giftAt - total),
        saved: Math.max(0, compare - base) + extraSaved + (unlocked ? cfg.giftPrice : 0)
      };
    }

    /* ---------- dates ---------- */

    // The three step row gives each line about twenty characters, so the arrival
    // date is a date and nothing else. The long sentence it replaced wrapped to
    // three lines and broke the row.
    function dayLabel(offset, long) {
      var d = new Date();
      d.setDate(d.getDate() + offset);
      return d.toLocaleDateString(undefined, long
        ? { weekday: 'short', month: 'short', day: 'numeric' }
        : { month: 'short', day: 'numeric' });
    }

    function paintDates() {
      var a = one('day-0'), b = one('day-ship'), c = one('day-arrive');
      if (a) a.textContent = dayLabel(0, true);
      if (b) b.textContent = dayLabel(cfg.shipFrom) + ' to ' + dayLabel(cfg.shipTo);
      if (c) c.textContent = dayLabel(cfg.arriveFrom) + ' to ' + dayLabel(cfg.arriveTo);
    }


    /* ---------- the brush run ----------
     * Drawn once per visitor, then walked down while she is on the page.
     *
     * The whole point is that it PERSISTS. A counter that draws a new number on
     * every reload tells the visitor it is invented, which costs more trust than
     * no counter buys. So the count and the moment it was last moved are stored,
     * and a reload resumes from exactly where it was.
     *
     * It only falls while the tab is actually being looked at, and it stops at a
     * floor rather than walking to zero and calling itself sold out.
     *
     * Storage can throw in a private window and can come back empty, so every read
     * and write is guarded and the counter works without it.
     */
    function stock(root) {
      var el = root.querySelector('[data-olv="stock"]');
      if (!el) return;
      var d = el.dataset;
      var nEl = root.querySelector('[data-olv="stock-n"]');
      var fillEl = root.querySelector('[data-olv="stock-fill"]');
      var min = +d.min || 100, max = +d.max || 200;
      var floor = +d.floor || 30, scale = +d.scale || max;
      var tickMin = (+d.tickMin || 10) * 1000, tickMax = (+d.tickMax || 20) * 1000;
      var dropMin = +d.dropMin || 1, dropMax = +d.dropMax || 2;
      var key = d.key || 'olv-stock';
      var timer = null;

      function between(a, b) { return a + Math.floor(Math.random() * (b - a + 1)); }

      function load() {
        try {
          var raw = window.localStorage.getItem(key);
          if (!raw) return null;
          var v = JSON.parse(raw);
          if (typeof v.n !== 'number' || v.n > max) return null;
          if (typeof v.floor === 'number') floor = v.floor;
          return v;
        } catch (e) { return null; }
      }
      function save(n) {
        try { window.localStorage.setItem(key, JSON.stringify({ n: n, at: Date.now(), floor: floor })); }
        catch (e) { /* private window, or storage is full. The counter still runs. */ }
      }

      // What the run did while she was away.
      //
      // Resuming on the exact number she left is right after a refresh and wrong after
      // two days: nobody bought a brush in forty eight hours. So time away is spent,
      // but slower than time watched, and never more than a slice of the distance to
      // the floor in one return. That keeps a long absence plausible instead of
      // dumping the counter onto the floor the first time she comes back next week.
      var AWAY_PER_MIN = 0.4;      // about one every two and a half minutes
      var AWAY_GRACE_MS = 90000;   // a refresh or a tab switch costs nothing
      var AWAY_MAX_SHARE = 0.55;   // at most this much of the gap to the floor, per return

      function spendTimeAway(v) {
        var gone = Date.now() - (v.at || Date.now());
        if (gone <= AWAY_GRACE_MS) return v.n;
        var want = Math.floor((gone / 60000) * AWAY_PER_MIN);
        var room = Math.floor((v.n - floor) * AWAY_MAX_SHARE);
        return Math.max(floor, v.n - Math.min(want, room));
      }

      var saved = load();
      var count;
      if (saved) {
        count = spendTimeAway(saved);
        if (count !== saved.n) save(count);
      } else {
        // The floor is drawn per visitor too. A shared round number is the thing two
        // people compare and catch.
        floor = between(Math.max(8, floor - 8), floor + 8);
        count = between(min, max);
        save(count);
      }

      function paint() {
        if (nEl) nEl.textContent = count;
        if (fillEl) fillEl.style.width = Math.max(4, Math.min(100, Math.round(count / scale * 100))) + '%';
      }

      function drop(by) {
        if (document.hidden || count <= floor) return;   // a background tab is nobody watching
        count = Math.max(floor, count - Math.max(1, by));
        save(count);
        paint();
      }

      // A purchase toast on the page OWNS the counter. Its own clock is only a
      // fallback for a page with no toast, or one whose feed never loaded, and it
      // waits far longer than a toast cycle so the two can never both fire.
      var toastDrives = !!document.querySelector('.olv-toast');
      var idleMs = Math.max(tickMax * 4, 90000);

      function arm() {
        clearTimeout(timer);
        if (count <= floor) { timer = null; return; }
        timer = setTimeout(tick, toastDrives ? idleMs : between(tickMin, tickMax));
      }

      function tick() { drop(between(dropMin, dropMax)); arm(); }

      // The purchase toast announces every order it shows. When it is on the page the
      // counter follows IT rather than a clock of its own, so the number falls in the
      // same second the toast says someone bought, and it falls by what they bought.
      // Two urgency widgets ticking on unrelated timers is what makes both read as fake.
      document.addEventListener('olivine:purchase', function (ev) {
        var qty = (ev.detail && ev.detail.qty) || 1;
        drop(Math.min(qty, dropMax));
        arm();   // the toast just moved it, so the fallback clock starts over
      });

      paint();
      arm();
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && !timer) arm();
      });
    }


    /* ---------- the sticky bar ----------
     * Shown only while NEITHER real button is on screen. Two calls to action in one
     * view is what made the advertorial read as broken, and the rule holds here.
     * It carries the same data-olv hooks as the inline button, so render() labels it
     * and the click handler checks it out, with no second copy of either.
     */
    function sticky(root) {
      var bar = root.querySelector('[data-olv="sticky"]');
      if (!bar) return;
      var real = Array.prototype.filter.call(
        root.querySelectorAll('[data-olv="checkout"]'), function (b) { return b !== bar && !bar.contains(b); });
      if (!real.length) return;

      function show(on) {
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        var btn = bar.querySelector('[data-olv="checkout"]');
        if (btn) btn.tabIndex = on ? 0 : -1;
        // the purchase toast is fixed to the same edge, so tell it how much room to leave
        var root_ = document.documentElement;
        root_.classList.toggle('olv-has-sticky', on);
        if (on) root_.style.setProperty('--olv-sticky-h', Math.round(bar.getBoundingClientRect().height) + 'px');
      }

      if (!('IntersectionObserver' in window)) { show(true); return; }
      var seen = new WeakMap();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
        var anyVisible = real.some(function (b) { return seen.get(b); });
        show(!anyVisible);
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
      real.forEach(function (b) { io.observe(b); });
    }

    /* ---------- render ---------- */

    function render() {
      var t = totals();

      root.querySelectorAll('.olv-shade').forEach(function (b) {
        var on = b.dataset.shade === state.shade;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      var dbl = one('double');
      if (dbl) {
        dbl.classList.toggle('is-on', state.doubled);
        dbl.setAttribute('aria-pressed', state.doubled ? 'true' : 'false');
        var st = one('double-state');
        if (st) st.textContent = state.doubled ? cfg.doubleOn : cfg.doubleAdd;
      }

      var sub = one('deal-sub');
      if (sub) sub.textContent = state.doubled ? cfg.offerSubDouble : cfg.offerSub;
      var dp = one('deal-price');
      if (dp) dp.textContent = money(t.base);
      var dw = one('deal-was');
      if (dw) dw.textContent = money(state.doubled ? cfg.quadCompare : cfg.bogoCompare);

      addonNodes().forEach(function (b) {
        var on = !!state.addons[b.dataset.key];
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var btn = b.querySelector('[data-olv="addon-btn"]');
        if (btn) btn.textContent = on ? cfg.addonAdded : cfg.addonAdd;
      });

      $('total').forEach(function (el) { el.textContent = money(t.total); });
      var sv = one('saved');
      if (sv) sv.textContent = money(t.saved);
      $('cta-label').forEach(function (el) {
        el.textContent = state.doubled ? cfg.ctaDouble : cfg.ctaSingle;
      });

      var pk = one('picked');
      if (pk) {
        var line = (state.doubled ? cfg.offerSubDouble : cfg.offerSub) + ', in ' + state.shade;
        if (t.picked.length) line += '. Plus ' + t.picked.join(' and ');
        if (t.unlocked) line += '. Free ' + cfg.giftName + ' included.';
        pk.textContent = line;
      }

      var sum = one('addon-sum');
      if (sum) {
        sum.classList.toggle('is-on', t.picked.length > 0);
        sum.textContent = t.picked.length
          ? t.picked.length + (t.picked.length === 1 ? ' add on added' : ' add ons added')
          : cfg.addonEmpty;
      }

      var gift = one('gift');
      if (gift) {
        gift.classList.toggle('is-on', t.unlocked);
        var gt = one('gift-title'), gs = one('gift-sub'), gf = one('gift-fill');
        if (gt) gt.textContent = t.unlocked
          ? 'Free ' + cfg.giftName + ' unlocked'
          : 'Free ' + cfg.giftName + ' at ' + moneyShort(cfg.giftAt);
        if (gs) gs.textContent = t.unlocked
          ? 'It goes in the box at no charge.'
          : 'Add ' + money(t.toGo) + ' more and it is free.';
        if (gf) gf.style.width = Math.min(100, Math.round(t.total / cfg.giftAt * 100)) + '%';
      }
    }

    /* ---------- checkout ---------- */

    function lines() {
      var row = shadeRow();
      var items = [];
      if (state.doubled) {
        // one 4 pack line at its own price, plus TWO free brushes. The 4 pack carries
        // no quantity_break_tiers, so nothing halves it and nothing rides along.
        if (!row.quad) return null;
        items.push({ id: row.quad, quantity: 1 });
        items.push({ id: cfg.softset, quantity: 2 });
      } else {
        // two serum units, which the discount function turns into one paid bottle.
        items.push({ id: row.solo, quantity: 2 });
        items.push({ id: cfg.softset, quantity: 1 });
      }
      addonNodes().forEach(function (b) {
        if (state.addons[b.dataset.key]) items.push({ id: parseInt(b.dataset.variant, 10), quantity: 1 });
      });
      if (totals().unlocked) items.push({ id: cfg.angled, quantity: 1 });
      return items;
    }

    function fail() {
      busy = false;
      root.classList.remove('is-busy');
      var e = one('err');
      if (e) e.hidden = false;
    }

    function checkout() {
      if (busy) return;
      var items = lines();
      if (!items) { fail(); return; }
      busy = true;
      root.classList.add('is-busy');
      var e = one('err');
      if (e) e.hidden = true;

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) {
          // /cart/add.js answers 422 with a JSON body when a variant cannot be added.
          // Jumping to /checkout on that would send her to an empty or wrong cart.
          if (!r.ok) throw new Error('add failed ' + r.status);
          return r.json();
        })
        .then(function (added) {
          if (!added || !added.items || !added.items.length) throw new Error('nothing added');
          window.location.href = '/checkout';
        })
        .catch(fail);
    }

    /* ---------- wiring ---------- */

    root.addEventListener('click', function (ev) {
      var shade = ev.target.closest('.olv-shade');
      if (shade && root.contains(shade)) {
        state.shade = shade.dataset.shade;
        render();
        return;
      }
      var dbl = ev.target.closest('[data-olv="double"]');
      if (dbl && root.contains(dbl)) {
        state.doubled = !state.doubled;
        render();
        return;
      }
      var addon = ev.target.closest('[data-olv="addon"]');
      if (addon && root.contains(addon)) {
        var k = addon.dataset.key;
        state.addons[k] = !state.addons[k];
        render();
        return;
      }
      var go = ev.target.closest('[data-olv="checkout"]');
      if (go && root.contains(go)) {
        ev.preventDefault();
        checkout();
      }
    });

    paintDates();
    stock(root);
    render();
    sticky(root);
  }
})();
